import React, { Fragment, useEffect } from "react";
import Moment from "react-moment";

let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const JobApplicationPost = ({
  post,
  JobApplication,
  setJobApplication,
  setCloseJobPost,
}) => {
  useEffect(() => {
    setJobApplication({
      ...JobApplication,
      id: post._id,
      channelid: post.channelid,
      jobtitle: post.jobtitle,
      location: post.location,
      employmenttype: post.employmenttype,
      applicants:
        post.applicants && post.applicants.length > 0
          ? [
              post.applicants.filter((x) => {
                return x.declinedapplicant === false;
              }),
            ].flat()
          : [],
      acceptedapplicants:
        post.acceptedapplicants.length > 0
          ? [post.acceptedapplicants].flat()
          : [],
    });
  }, []);

  return (
    <Fragment>
      <div className="job-post blue">
        <div className="job-post-date">
          <i className="far fa-clock"></i>
          <p className="mx-5 white">
            <Moment format="MM/DD/YYYY">{post.date}</Moment>
          </p>
        </div>
        <ul className="post-items">
          <li className="post-item">{post.jobtitle}</li>
          <li className="post-item">
            {post.location.city}, {post.location.state}
          </li>
          <li className="post-item">{post.employmenttype}</li>
          {post.salary > 0 ? (
            <li className="post-item">{formatter.format(post.salary)}</li>
          ) : (
            <li className="post-item">Salary Not Listed</li>
          )}
          <li className="post-item">
            Applicants
            <span className="white mx-5">
              (
              {post.applicants.length > 0
                ? post.applicants.filter((x) => !x.declinedapplicant).length
                : "0"}
              )
            </span>
          </li>
          <li className="post-item-alert red">
            <i className="fas fa-exclamation-circle mr-5 red"></i>
            Expires in <Moment date={post.expirationdate} durationFromNow />
          </li>
        </ul>
        <button
          className="applicant-button background-dark-black white"
          onClick={() => {
            setJobApplication({
              ...JobApplication,
              id: post._id,
              channelid: post.channelid,
              jobtitle: post.jobtitle,
              location: post.location,
              employmenttype: post.employmenttype,
              applicants:
                post.applicants && post.applicants.length > 0
                  ? [
                      post.applicants.filter((x) => {
                        return x.declinedapplicant === false;
                      }),
                    ].flat()
                  : [],
              acceptedapplicants:
                post.acceptedapplicants.length > 0
                  ? [post.acceptedapplicants].flat()
                  : [],
            });
          }}
        >
          <i className="fas fa-file-alt blue mx-5"></i>Manage Applicants
        </button>
        <button
          className="applicant-button-alt background-red"
          onClick={() => {
            setJobApplication({
              ...JobApplication,
              id: post._id,
              channelid: post.channelid,
              jobtitle: post.jobtitle,
              location: post.location,
              employmenttype: post.employmenttype,
              applicants:
                post.applicants.length > 0
                  ? [
                      post.applicants.filter((x) => {
                        return x.declinedapplicant === false;
                      }),
                    ]
                  : [],
              acceptedapplicants:
                post.acceptedapplicants.length > 0
                  ? [post.acceptedapplicants]
                  : [],
            });
            setCloseJobPost(true);
          }}
        >
          <i className="fas fa-times mx-5"></i>Close Job Post
        </button>
      </div>
    </Fragment>
  );
};

export default JobApplicationPost;
